export default [
  {
    path: '/etreasury/:key?',
    name: 'etreasury',
    component: () => import('@/views/etreasury/EtreasuryIndex.vue'),
    meta: {},
  },
];
